const FilterButton = ({ label, isActive, onClick, styles }) => (
  <button className={isActive ? styles : ""} onClick={onClick}>
    {label}
  </button>
);

export default FilterButton;
